import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import {isBrowser} from 'react-device-detect';
import errorImage from 'app/Components/Block/BusinessDashboardBlock/assets/images/error.svg';

const PortalErrorDisplay = ({contentData}) => {
  const {errorTitle, errorSubtitle} = contentData || {};

  return (
    <div className='business-dashboard-portals-error-container'>
      <div className='portals-error-content'>
        <Image src={errorImage} className='portals-error-image' />
        <div className='portals-error-titles'>
          <span className='portals-error-main-title'>{errorTitle?.value}</span>
          <span className='portals-error-subtitle'>{errorSubtitle?.value}</span>
        </div>
      </div>
    </div>
  );
};


export default PortalErrorDisplay;
